// Module
var code = "<a class=\"text-sm sps-btn sps-btn-outline btn-color-return return-button\" data-bind=\"style: _style\"> <i class=\"fa fa-mail-reply-all\" align=\"center\"></i> <!-- ko text: _labels.RETURN --><!-- /ko --> </a>";
// Exports
export default code;